export default "__VITE_ASSET__714827ce__"